<p-confirmDialog key="stationblockalertadd" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Options-->
<div class="ItemBorder">
	<h4 style="text-align: center">Options:</h4>
	<div class="MainGrid2Col">
		<label>School:</label>
		<label class="InfoText">{{ SchoolName }}</label>

		<label>Message:</label>
		<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="Message" maxlength="100" />

		<label>Date Range:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="DateRangeID" [(ngModel)]="DateRangeID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstDateRange" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>

		<label *ngIf="DateRangeID == 2 || DateRangeID == 3">Start Date:</label>
		<p-calendar
			*ngIf="DateRangeID == 2 || DateRangeID == 3"
			[disabled]="IsLoading() == true"
			showIcon="true"
			showButtonBar="true"
			[(ngModel)]="StartDate"
			name="StartDate"
			appendTo="body"
		></p-calendar>

		<label *ngIf="DateRangeID == 2 || DateRangeID == 4">End Date:</label>
		<p-calendar
			*ngIf="DateRangeID == 2 || DateRangeID == 4"
			[disabled]="IsLoading() == true"
			showIcon="true"
			showButtonBar="true"
			[(ngModel)]="EndDate"
			name="EndDate"
			appendTo="body"
		></p-calendar>

		<label>Time Range:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="TimeRangeID" [(ngModel)]="TimeRangeID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstTimeRange" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>

		<label *ngIf="TimeRangeID == 2 || TimeRangeID == 3">Start Time:</label>
		<p-calendar
			*ngIf="TimeRangeID == 2 || TimeRangeID == 3"
			[disabled]="IsLoading() == true"
			showIcon="true"
			showButtonBar="true"
			timeOnly="true"
			showTime="true"
			hourFormat="12"
			[(ngModel)]="StartTime"
			name="StartTime"
			appendTo="body"
		></p-calendar>

		<label *ngIf="TimeRangeID == 2 || TimeRangeID == 4">End Time:</label>
		<p-calendar
			*ngIf="TimeRangeID == 2 || TimeRangeID == 4"
			[disabled]="IsLoading() == true"
			showIcon="true"
			showButtonBar="true"
			timeOnly="true"
			showTime="true"
			hourFormat="12"
			[(ngModel)]="EndTime"
			name="EndTime"
			appendTo="body"
		></p-calendar>

		<label>Priority:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="PriorityID" [(ngModel)]="PriorityID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstPriority" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>
	</div>
</div>

<!--Init List-->
<div class="ItemBorder TopMargin">
	<div>
		<div class="HeaderFlex">
			<h4>Homeroom(s):</h4>
			<button class="btn btn-primary" (click)="onAddHomeroom()">Add</button>
		</div>

		<div>
			<p-table
				#mydt
				[value]="lstHomeroom"
				[loading]="IsLoading() == true"
				[paginator]="true"
				[(rows)]="HomeroomPageRows"
				[(first)]="HomeroomPageFirst"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				dataKey="HomeroomID"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10, 25, 50]"
			>
				<!--Headers-->
				<ng-template pTemplate="header">
					<!--Column Names-->
					<tr style="height: 4rem">
						<th pSortableColumn="Homeroom">Homeroom<p-sortIcon field="Homeroom"></p-sortIcon></th>
						<th class="SmallCol"></th>
					</tr>
				</ng-template>

				<!--Data-->
				<ng-template pTemplate="body" let-Homeroom>
					<tr [pSelectableRow]="Homeroom">
						<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
							{{ Homeroom.Homeroom }}
						</td>
						<td class="SmallCol">
							<button class="btn btn-danger" (click)="onRemoveHomeroom(Homeroom)"><i class="fa fa-times" aria-hidden="true"></i></button>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>

	<div class="DividerLine"></div>

	<div>
		<div class="HeaderFlex">
			<h4>Group(s):</h4>
			<button class="btn btn-primary" (click)="onAddGroup()">Add</button>
		</div>

		<div>
			<p-table
				#mydt
				[value]="lstGroup"
				[loading]="IsLoading() == true"
				[paginator]="true"
				[(rows)]="GroupPageRows"
				[(first)]="GroupPageFirst"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				dataKey="GroupID"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10, 25, 50]"
			>
				<!--Headers-->
				<ng-template pTemplate="header">
					<!--Column Names-->
					<tr style="height: 4rem">
						<th pSortableColumn="GroupName">Group<p-sortIcon field="GroupName"></p-sortIcon></th>
						<th class="SmallCol"></th>
					</tr>
				</ng-template>

				<!--Data-->
				<ng-template pTemplate="body" let-Group>
					<tr [pSelectableRow]="Group">
						<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
							{{ Group.GroupName }}
						</td>
						<td class="SmallCol">
							<button class="btn btn-danger" (click)="onRemoveGroup(Group)"><i class="fa fa-times" aria-hidden="true"></i></button>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>

	<div class="DividerLine"></div>

	<div>
		<div class="HeaderFlex">
			<h4>Student(s):</h4>
			<button class="btn btn-primary" (click)="onAddPerson()">Add</button>
		</div>

		<div>
			<p-table
				#mydt
				[value]="lstPerson"
				[loading]="IsLoading() == true"
				[paginator]="true"
				[(rows)]="PersonPageRows"
				[(first)]="PersonPageFirst"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				dataKey="PersonID"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10, 25, 50]"
			>
				<!--Headers-->
				<ng-template pTemplate="header">
					<!--Column Names-->
					<tr style="height: 4rem">
						<th pSortableColumn="StudentID">Student ID<p-sortIcon field="StudentID"></p-sortIcon></th>
						<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
						<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
						<th class="SmallCol"></th>
					</tr>
				</ng-template>

				<!--Data-->
				<ng-template pTemplate="body" let-Person>
					<tr [pSelectableRow]="Person">
						<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
							{{ Person.StudentID }}
						</td>
						<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
							{{ Person.FirstName }}
						</td>
						<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
							{{ Person.LastName }}
						</td>
						<td class="SmallCol">
							<button class="btn btn-danger" (click)="onRemovePerson(Person)"><i class="fa fa-times" aria-hidden="true"></i></button>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button [disabled]="Processing == true" class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
